import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const BlogTestimonials = ({ data, bg }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section className={`${bg ? "bg-white" : "bg-[#f5f9fb]"} py-10 xs:py-1`}>
            <div className="text-center mx-auto max-w-7xl xs:p-4">
                <h1 className="text-6xl xs:text-center xs:text-4xl mb-20 xs:mb-2 xs:mt-10 xs:pt-4 xs:pb-8">{data.title}</h1>

                <Swiper
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    slidesPerView={isMobile ? 1 : 3}
                    spaceBetween={30}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    className="w-full"
                >
                    {data.testimonial.map((testimonial, index) => (
                        <SwiperSlide key={index}>
                            <div className={`${bg ? "bg-[#faf9f9]" : "bg-white"}`}>
                                <div className="h-80">
                                    <img
                                        src={testimonial.image}
                                        className="w-full h-full object-cover"
                                        alt=""
                                    />
                                </div>
                                <div className="text-start p-4">
                                    <h3 className="text-medium text-gray-400 mt-3">{testimonial.date}</h3>
                                    <h3 className="text-xl text-[#262626]">{testimonial.title}</h3>
                                    <p className="h-30 text-[#696868] text-lg">{testimonial.text}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="swiper-pagination !relative !mt-6 !mb-2 !z-10 flex justify-center" />

                <style>{`
          .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            margin: 0 6px;
            opacity: 0.5;
            background-color: black;
            border-radius: 100%;
            transition: all 0.3s ease;
          }
          .swiper-pagination-bullet-active {
            opacity: 1;
            background-color: #EC0000 !important;
          }
        `}</style>
            </div>
        </section>
    );
};

export default BlogTestimonials;
